import React from 'react'
import { Row, Col } from 'antd';
import ContributionDatePicker  from "./ContributionDatePicker"
import ContributionDetails from "./ContributionDetails"
import ContributionsTable from "./ContributionsTable"
import { getFundsApi, getContributionApi } from '../../services/apiService'
import { showApiError} from '../utilities'
import { record_operation } from '../enums'
import moment from 'moment'

class Contributions extends React.Component {
  constructor(props) {
    super(props)
    let today = new Date()
    today.setHours(0,0,0,0)
    this.state = {
      contributions:[],
      contributionDate: today,
      selectedRow: 0,
      contribution: {},
      loading: true,
      showDetails: false
    }
    this.funds = []
    this.organisationId = parseInt(window.sessionStorage.getItem("OrganisationId"))
  }
  componentDidMount() {
    this.getFunds()
    this.getContributions( this.state.contributionDate )
  }

  getContributions = ( contributionDate, contributionId ) => {
    let dstring = moment(contributionDate ).format("YYYYMMDD")
    getContributionApi(dstring)
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {
          //console.log(json)
          let selectedRow = -1
          let contribution = {}
          let showDetails = false
          if (json.length > 0) {
            //console.log("getContributions")
            //console.log(json)
            let Index = json.findIndex(contribution => contribution.contributionId === contributionId) 
            Index = Index > -1 ? Index : 0
            contribution = json[ Index ]
            selectedRow = Index
            showDetails = true
          }

          this.setState({
            contributions: json,
            selectedRow: selectedRow,
            contribution: contribution,
            contributionDate,
            loading: false,
            showDetails
          })
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }

  getFunds = () => {
    getFundsApi()
      .then(json => {
        if (typeof json === 'string') {
          throw new Error(json)
        } else {
          this.funds = json 
          //console.log(this.funds)
        }
      })
      .catch(error => {
        showApiError(error)
      })
  }

  handleDatePickChange = ( d, ds) => {
    this.getContributions(d.toDate())
  }

  handleSelectRow = (id) => {

    let rowIndex = this.state.contributions.findIndex((c) => c.contributionId === id)
    let contribution = this.state.contributions.find((c) => c.contributionId === id)
    this.setState({ selectedRow: rowIndex , contribution})

  }

  handlePostSave = (json, operation) => {
    // json should be the contribution data
    // refresh the contribution
    //console.log(operation)
    //console.log(json)
    let Id = -1
    let contributionDate = json.contributionDate || moment(this.state.contributionDate)
    switch (operation) {
      case record_operation.ADD:
        Id = json.contributionId
        break;
      case record_operation.UPDATE:
        Id = json.contributionId
        break;
      case record_operation.DELETE:
        break;
      default:
        break;
    }

    this.getContributions(contributionDate, Id)
    //this.setState({
    //  contributions: json,
    //  selectedRow,
    //  contribution,
    //  contributionDate,
    //  loading: false,
    //  showDetails 
    //})


  }

  defaultlines = () => {
    let lines = []
    let newId = -1
    this.funds
      .filter((f) => f.active)
      .map((f) => {
        lines.push({
          "fund": f.description,
          "amount": "",
          "contributionLineId": newId
        })
        newId = newId - 1
        return f
      })
    return lines
  }

  handleAddNew = () => {
    //console.log("add new row")
    let showDetails = true
    this.setState({ contribution: this.getNewContribution(), showDetails} ) 
    
  }

  getNewContribution = () => {

    //let jsonDate =  moment( this.state.contributionDate ).format("YYYY-MM-DD")
    let contributionDate = moment(this.state.contributionDate).format("YYYY-MM-DD")  // only want to date part
    //console.log(contributionDate)  
    return {
      organisationId: this.organisationId,
      contributionId: -1,
      contributionDate: contributionDate ,
      contributorId: -1,
      "offeringNo": -1,
      "displayName": "",
      "contributionLines": this.defaultlines()
    }
  }



  render() {

    const ShowContributionDetails = ({ funds, thisState } ) => {
      if (thisState.showDetails) {
        return <ContributionDetails
          contribution={thisState.contribution} key={thisState.contribution.contributionId}
          contributionDate={thisState.contributionDate} postSave={this.handlePostSave}
          funds={funds} />
      } else {
        return null
      }

    }

    let container  = <div>loading...</div>
    if (!this.state.loading) {
      container = <div className="content">
        <h2>{this.props.title}</h2>
        <Row>
          <Col span={12} style={{ paddingRight: 5 }}>
            <ContributionDatePicker contributionDate={this.state.contributionDate}
              onChange={this.handleDatePickChange} addNewRow={this.handleAddNew} key={this.state.contributionDate.toString()} /> 
            <ContributionsTable contributions={this.state.contributions}
              selectedRow={this.state.selectedRow}
              rowClick={this.handleSelectRow} />
          </Col>
          <Col span={12}><ShowContributionDetails funds={this.funds} thisState={this.state}/>
          </Col>
        </Row>

      </div>

    }

    return <React.Fragment> {container} </React.Fragment>
  }
}

export default Contributions;
